import { use } from "react";
import { AuthContext, type IAuthContext } from "react-oauth2-code-pkce";
import { useTranslation } from "react-i18next";
import { Container } from "../../components/SDS/Container";
import { Grid, Button } from "@sede-enterprise/shell-ds-react-framework";

const COLOR_WARNING_DARK = "var(--shell-color-warning-dark, #d97706)";
const COLOR_WARNING_MAIN = "var(--shell-color-warning-main, #f59e0b)";

const Unauthorized: React.FC = () => {
  const { logIn }: IAuthContext = use(AuthContext);
  const { t } = useTranslation();

  const handleTryAgain = () => {
    sessionStorage.clear();

    if (window.location.search) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    logIn();
  };

  return (
    <Container>
      <Grid>
        <Grid.Cell>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "60vh",
              textAlign: "center",
              padding: "2rem",
            }}
          >
            {/* Error Title */}
            <h1
              style={{
                fontSize: "3rem",
                fontWeight: "bold",
                color: COLOR_WARNING_MAIN,
                lineHeight: "1",
                marginBottom: "1rem",
                textShadow: "0 2px 4px rgba(245, 158, 11, 0.1)",
              }}
            >
              {t("errors.unauthorized.title", "Access Denied")}
            </h1>

            {/* Error Description */}
            <p
              style={{
                fontSize: "1.125rem",
                color: "var(--shell-color-text-secondary, #6b7280)",
                marginBottom: "2rem",
                maxWidth: "600px",
                lineHeight: "1.6",
              }}
            >
              {t(
                "errors.unauthorized.description",
                "You have been authenticated successfully, but you don't have the necessary permissions to access this application. Please contact your administrator to request access.",
              )}
            </p>

            {/* Try Again Button */}
            <Button
              onClick={handleTryAgain}
              style={{
                marginTop: "0.5rem",
                marginBottom: "1.5rem",
                minWidth: "120px",
              }}
            >
              {t("errors.unauthorized.tryAgain", "Try Again")}
            </Button>

            {/* Contact Information */}
            <div
              style={{
                marginTop: "3rem",
                padding: "1.5rem",
                backgroundColor: "var(--shell-color-warning-subtle, #fef3c7)",
                borderRadius: "8px",
                border: `1px solid ${COLOR_WARNING_MAIN}`,
                maxWidth: "500px",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.1)",
              }}
            >
              <h3
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: COLOR_WARNING_DARK,
                  marginBottom: "0.5rem",
                }}
              >
                {t("errors.unauthorized.contactTitle", "Need Access?")}
              </h3>
              <p
                style={{
                  fontSize: "0.875rem",
                  color: "var(--shell-color-text-secondary, #6b7280)",
                  margin: 0,
                  lineHeight: "1.5",
                  marginBottom: "1rem",
                }}
              >
                {t(
                  "errors.unauthorized.contactText",
                  "To gain access to this application, please contact your system administrator at",
                )}{" "}
                <a
                  href="mailto:GXDSONESOURCEIT@shell.com"
                  style={{
                    color: COLOR_WARNING_DARK,
                    textDecoration: "none",
                    fontWeight: "600",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.textDecoration = "underline";
                    e.currentTarget.style.color = COLOR_WARNING_MAIN;
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.textDecoration = "underline";
                    e.currentTarget.style.color = COLOR_WARNING_MAIN;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.textDecoration = "none";
                    e.currentTarget.style.color = COLOR_WARNING_DARK;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.textDecoration = "none";
                    e.currentTarget.style.color = COLOR_WARNING_DARK;
                  }}
                >
                  GXDSONESOURCEIT@shell.com
                </a>{" "}
                {t(
                  "errors.unauthorized.contactTextContinued",
                  "or your IT support team with your user credentials.",
                )}
              </p>
            </div>
          </div>
        </Grid.Cell>
      </Grid>
    </Container>
  );
};

export default Unauthorized;
